import { E_REQUEST_METHOD } from '../ServicesHelpers';
import { serviceCreator } from 'src/services/helpers/serviceCreator';
import { API_ENDPOINT } from '../constants';
export var authServices = {
    fetchPermissions: function (realm, payload) {
        return serviceCreator(E_REQUEST_METHOD.POST, API_ENDPOINT.IAM.PERMISSION(realm), true, {
            data: payload,
            enableDefaultEvents: true,
        });
    },
    fetchGroups: function (realm) {
        return serviceCreator(E_REQUEST_METHOD.GET, API_ENDPOINT.IAM.GROUPS(realm), true, {
            enableDefaultEvents: true,
        });
    },
};
